import { dataLayerName } from './constants'
import { DataLayer } from './data-layer'

export const getDataLayer = <Data, Meta>(): DataLayer<Data, Meta> | undefined => {
  if (typeof window !== 'undefined') {
    return (window as Window & typeof globalThis & { dhlDataLayer: DataLayer<Data, Meta> })[dataLayerName]
  }
  return undefined
}
